import {
    Component,
    ComponentDefinition,
} from "components/components/Component";
import i18n from "components/i18n/i18n";
import {
    Renderer,
} from "components/Renderer";
import hljs from "highlight.js/lib/highlight";
import java from "highlight.js/lib/languages/java";
import xml from "highlight.js/lib/languages/xml";
import "highlight.js/styles/rainbow.css";
import marked from "marked";
import { stringify } from "flatted";
import template from "./lds_row.hbs";
import "./lds_row.scss";

hljs.registerLanguage("java", java);
hljs.registerLanguage("xml", xml);

marked.setOptions({
    highlight(code) {
        return hljs.highlightAuto(code).value;
    },
    langPrefix: "hljs ",
});

export class LDSRow implements Component {
    public id;
    public componentType = "liveDesignSystemRow";
    public definition: LDSRowDefinition;
    private view: HTMLElement;
    private codeVisible = false;

    constructor(definition) {
        this.definition = definition;
    }

    public render = () => {
        const d = document.createElement("div");
        this.view = d.firstChild as HTMLElement;
        d.innerHTML = template(Object.assign(this.definition, {
            sourceString: JSON.stringify(
                this.definition.source,
                null,
                "\t",
            ),
            formattedText: marked(
                LDSRow.mergeMessage(this.definition.text),
            ),
        }));
        this.view = d.firstChild as HTMLElement;
        if (this.definition.sourceUrl != null) {
            fetch(this.definition.sourceUrl)
                .then((response) => response.text())
                .then((data) => {
                    this.view.querySelector("textarea").value = data;
                    this.updateFromDefinition();
                });

        }
        if (this.definition.textUrl != null) {
            fetch(this.definition.textUrl)
                .then((r) => r.text())
                .then((data) => {
                    this.view.querySelector(".c-lds-row__formatted-text").innerHTML = marked(data);
                });
        }
        this.view.addEventListener("dataChanged", (e) => {
            const d = JSON.parse(stringify(e["detail"]));
            e.stopPropagation();
            if (window["sislog"]?.["debug"]?.["storeLdsChanges"]) {
                window["sislog"]["debug"]["ldsChanges"] = window["sislog"]["debug"]["ldsChanges"] ?? [];
                window["sislog"]["debug"]["ldsChanges"].push(d);
            }
            console.info("Data change detected ", d);
        });
        this.addEvents(this.view);
        return this.view;
    }

    private static mergeMessage(def): string {
        let message;
        if (Array.isArray(def)) {
            message = def.join("\n");
        } else {
            message = i18n.instance.t(def);
            if (Array.isArray(message)) {
                message = message.join("\n");
            }
        }
        return message;
    }

    public postRender() {
        this.updateFromDefinition();
    }

    private addEvents(node: Element) {
        const button = node.querySelector(".js-lds-row__apply-button");
        const showButton = node.querySelector(".showButton");
        button.addEventListener("click", () => {
            this.updateFromDefinition();
        });
        showButton.addEventListener("click", () => {
            this.showJson(node);
        });
    }

    private updateFromDefinition() {
        const definitionString: string =
            (this.view.querySelector(".js-lds-row__textarea") as HTMLTextAreaElement).value;
        if (definitionString == null || definitionString === "") {
            return;
        }
        const target = this.view.querySelector(".js-lds-row__preview-pane");
        const definition = JSON.parse(definitionString);
        Renderer.instance().fullRender(definition, target);
    }

    private showJson(node: Element) {
        const textArea = node.querySelector(".js-lds-row__textarea") as HTMLElement;
        const applyButton = node.querySelector(".js-lds-row__apply-button") as HTMLElement;

        if (this.codeVisible === false) {
            textArea.style.display = "block";
            applyButton.style.display = "inline-block";
            this.codeVisible = true;
        } else {
            textArea.style.display = "none";
            applyButton.style.display = "none";
            this.codeVisible = false;
        }
    }
}

interface LDSRowDefinition extends ComponentDefinition {
    title?: string;
    text?: string;
    textUrl?: string;
    source?: string;
    sourceUrl?: string;
}
